/* eslint-disable max-len */
/* eslint-disable import/prefer-default-export */

export const Arrow = ({classNames = ''}) => (
  <svg className={`arrow-svg ${classNames}`} xmlns='http://www.w3.org/2000/svg' width='50' height='50' viewBox='5 5 14 14' fill='none' fillOpacity='0'
    stroke='#111111' strokeWidth='2' strokeLinecap='round' strokeLinejoin='arcs'>
    <path d='M9 18l6-6-6-6'/>
  </svg>
);